import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitLegalDocuments } from './hooks'
import { TableLegalDocuments } from './TableLegalDocuments'
import { FormLegalDocuments } from './FormLegalDocuments'

export const LegalDocuments = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitLegalDocuments({location, paramsURL})

    const {
        globalStates,
        Actions
    } = useFetchInit

    const { showForm, setFormOpeningMode } = globalStates
    const { handleClickShowForm } = Actions

    return (
        <AllowedAccess permissions={['222_DOCUMENTOS']} renderAuthFailed={<p>Error</p>}>
            {(!showForm) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                
                                <div className='h4 mt-1 mb-1'> Documentos</div>
                                <div className="border-bottom border-dark"></div>
                                {/* {loadingFetchAllClients && ( <LinearLoading /> )} */}

                                <div className="d-flex justify-content-end pt-4">
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type="button"
                                        onClick={
                                            () => {
                                                setFormOpeningMode('EDITABLE')
                                                handleClickShowForm(true)
                                            }
                                        }
                                    >
                                        <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                    </Button>
                                </div>

                                <div className="pt-4"></div>
                                <TableLegalDocuments useFetchInit={useFetchInit} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            {(showForm) && (
                <FormLegalDocuments useFetchInit={useFetchInit} />
            )}
        </AllowedAccess>
    )
}
